import {WechatInitOptions} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {TokenService} from "../../token/tokenservice";
import {MailTokenService} from "../../token/mailtokenservice";

/**
 * 企业微信 成员
 */
export class UserService {

  /*
   * 读取部门成员列表
   * */
  static async getUserSimpleList(departmentId: number, fetchChild: boolean = true): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new MailTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "GET",
      uri: `${wechatOptions.corp.apiUrl}user/simplelist`,
      qs: {
        access_token: accessToken,
        department_id: departmentId,
        fetch_child: Number(fetchChild)
      },
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`get user list failed , response:`);
      console.error(result);
    }

    return "";
  }

  /*
   * 读取部门成员详情列表
   * */
  static async getUserList(departmentId: number, fetchChild: boolean = true): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new MailTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "GET",
      uri: `${wechatOptions.corp.apiUrl}user/list`,
      qs: {
        access_token: accessToken,
        department_id: departmentId,
        fetch_child: Number(fetchChild)
      },
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`get user list failed , response:`);
      console.error(result);
    }

    return "";
  }

}
